import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import sortBy from "lodash/sortBy";

import Button from "@mui/material/Button";

import {setLookActiveFeature, updateNavigationCount} from "../../../../../actions/lookFunctions";
import {navFeatureCLick} from "../../../lookNavigation/lookFunctions";
import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import Config, {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {allowCheckForCollection} from "../groheFunctions";
import {getSameFeatureWithAnotherMeta, getSkusDifferences} from "../../../lookNavigation/lookFunctions2";
import {usePrevious} from "../../../../../misc/helperHooks";
import WithClickCount from "../../../hocs/withClickCount";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {featureInterface} from "../../../../../interfaces/featureInterface";

const GroheFeatureOptionsType = (props) => {

  const {lookActiveFeature, filterGroups, setLookActiveFeature, lookActiveFeatureCustomName, updateCanvasCount,
    lookActiveFeatureCollection, isMobile, moreInfoOpened, lookActiveFeatureMatchingFeature, metaName = "MatchingFeature",
    intl, updateNavigationCount, parentOptionClick} = props;
  const [availableOptions, setAvailableOptions] = useState([]);
  const prevActiveFeature = usePrevious(lookActiveFeature);
  const checkCollectionName = lookActiveFeature && !allowCheckForCollection(lookActiveFeature) ? "" : lookActiveFeatureCollection;

  const updateOptions = () => {
    const colorOptions = getSameFeatureWithAnotherMeta(lookActiveFeature, filterGroups, metaName);
    const sorted = sortBy(colorOptions || [], ['obj', 'metaValue'])
    setAvailableOptions(sorted)
  }

  useEffect(() => {
    updateOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeatureCustomName, checkCollectionName, lookActiveFeatureMatchingFeature]);

  useEffect(() => {
    const shouldCheckSkuDIfference = (metaName !== "MatchingFeature") && prevActiveFeature && lookActiveFeature &&
      getSkusDifferences(prevActiveFeature.dbFeature.sharedFeatureName, lookActiveFeature.dbFeature.sharedFeatureName) > 1;
    if (shouldCheckSkuDIfference) {
      updateOptions()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature]);

  if (!availableOptions.length
    || availableOptions.length === 1
    || (!IS_PRODUCT_JOURNEY && isMobile && moreInfoOpened)
    || (lookActiveFeature && (lookActiveFeature.partId === "vanity_faucet" || !lookActiveFeature.metaData[metaName]))) {
    return null
  }

  const activeMetaDataValue = lookActiveFeature.metaData[metaName][0];

  const optionsButtonClick = (option, maxClickCountReached) => {
    const featureLabel = (Analytics.getStringForAnalytics(getValueText(option.metaValue))).toLowerCase() + "_" + Analytics.getSkuForAnalytics(lookActiveFeature);
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureOptions + featureLabel
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureOptions + featureLabel;
    Analytics.sendClickEvent(analyticsLabel);

    if (Config.isDevMode()) {
      console.log("option.feature", option.feature);
    }
    
    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }
    if (parentOptionClick) {
      parentOptionClick(option.feature)
    }
    setLookActiveFeature(option.feature);
    navFeatureCLick(option.feature);
    updateCanvasCount();
    updateNavigationCount();
    setTimeout(() => {
      updateCanvasCount();
    }, 0)
  };

  const getTitle = () => {
    switch (metaName) {
      case "CustomSinkSubCategory":
        return "grohe.feature.sinkType"
      case "MountHoles":
        return "grohe.feature.faucetType"
      case "MountPosition":
        return "grohe.feature.mountPosition"
      default:
        return "grohe.feature.mountType"
    }
  }

  const getValueText = (metaValue) => {
    switch (metaName) {
      case "MountHoles":
        switch (metaValue) {
          case "1":
            return intl.formatMessage({id: "grohe.feature.singleHole"})
          case "4":
            return intl.formatMessage({id: "grohe.feature.centerset"})
          case "8":
            return intl.formatMessage({id: "grohe.feature.widespread"})
          default:
            return metaValue
        }
      default:
        return metaValue
    }
  }

  return (
    <div className="lk-feature__options">
      <span className="lk-feature__options-title">
        <FormattedMessage id={getTitle()}/>:
        {/*{IS_PRODUCT_JOURNEY ? ":" : null}*/}
        {/*{activeMetaDataValue && (IS_PRODUCT_JOURNEY) ? (*/}
          <span className="lk-feature__options-title-text">{getValueText(activeMetaDataValue)}</span>
        {/*) : null}*/}
      </span>
      {/*{activeMetaDataValue && !IS_PRODUCT_JOURNEY ? (*/}
      {/*  <span className="lk-feature__options-sub-title">*/}
      {/*    ({getValueText(activeMetaDataValue)})*/}
      {/*  </span>*/}
      {/*) : null}*/}
      <WithClickCount>
        {(maxClickCountReached) => (
          <div className="lk-feature__options-list">
            {availableOptions.map(option => {
              const isActive = activeMetaDataValue && (option.metaValue === activeMetaDataValue);
              return (
                <Button className={"look-button look-button--half-radius look-button--option lk-type" + (isActive ? " look-button--option-active" : "")}
                        key={option.metaValue}
                        onClick={() => optionsButtonClick(option, maxClickCountReached)}>
                  {getValueText(option.metaValue)}
                </Button>
              )
            })}
          </div>
        )}
      </WithClickCount>
    </div>
  )
};

GroheFeatureOptionsType.propTypes = {
  metaName: PropTypes.string,
  parentOptionClick: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {moreInfoOpened} = store.lookState;
  const storeActiveFeature = store.lookState.lookActiveFeature;

  const {filterGroups} = store.filterState;
  const {isMobile} = store.serverState;

  const lookActiveFeature = ownProps.activeFeature || storeActiveFeature;

  const lookActiveFeatureCustomName = ownProps.metaName === "MatchingFeature"
    ? lookActiveFeature ? lookActiveFeature.getCustomFullDisplayName() : null
    : null;
  const lookActiveFeatureMatchingFeature = ownProps.metaName === "MatchingFeature"
    ? lookActiveFeature && Array.isArray(lookActiveFeature.dbFeature.metaData["MatchingFeature"])
      ? lookActiveFeature.dbFeature.metaData["MatchingFeature"].join(",")
      : null
    : null;
  return {
    lookActiveFeature,
    filterGroups,
    lookActiveFeatureCustomName,
    lookActiveFeatureMatchingFeature,
    lookActiveFeatureCollection: lookActiveFeature ? lookActiveFeature.getCollectionName(filterGroups) : null,
    isMobile,
    moreInfoOpened
  };
};

const mapDispatchToProps = {
  setLookActiveFeature,
  updateCanvasCount,
  updateNavigationCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureOptionsType)
)
